
import DetailMixin from '@/mixins/DetailMixin';

export default {
    mixins: [
        DetailMixin,
    ],

    props: {
        client: Object,
        isPerson: Boolean,
        asDriver: Boolean,
        masterRef: Object,
    },

    computed: {
        readonly() {
            // Hack to override computed property in mixin with Boolean pseudo-prop
            return this.$attrs.readonly === true || this.$attrs.readonly === '';
        },
    },

    watch: {
        client() {
            this.loadItem();
        },
    },

    methods: {
        loadItem() {
            if (!this.client) {
                this.editItem = $.getNu(this.collName);
                this.editItem.personRef = this.isPerson ? 0 : null;
            } else {
                this.item = this.client;

                if (this.readonly) {
                    this.editItem = this.item;
                } else {
                    this.initEdit();
                }
            }

            return true;
        },
    },
};
